export const formatEventInfo = (name, properties = {}) => ({ name, properties })
